module.exports = __webpack_public_path__ + "img/renew.238b83b3.png";